import { render, staticRenderFns } from "./RuleFlags.vue?vue&type=template&id=6c8e65a2"
import script from "./RuleFlags.vue?vue&type=script&lang=js"
export * from "./RuleFlags.vue?vue&type=script&lang=js"
import style0 from "./RuleFlags.vue?vue&type=style&index=0&id=6c8e65a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports